export default "__VITE_ASSET__Cw4Ox1T$__"